import React from "react";
import "./BotaoBusca.css";

const BotaoBusca = ({ onClick, children = "Buscar", disabled = false }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="botao-busca"
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default BotaoBusca;
